import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import Loader from '../components/Loader';
import { displayError } from '../utilities';
import {
  fetchSsoSession,
  getSSOLoginUrl,
  setAuthSession
} from '../utilities/auth';

const SSO = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authenticate = async () => {
      try {
        const userData = await fetchSsoSession();
        if (!userData || !userData.token) {
          throw new Error('Authentication failed: Missing token in response.');
        }

        setAuthSession(userData);
        window.location.replace('/');
      } catch (err) {
        const message =
          (err && err.message) || 'Failed to authenticate. Please try again.';
        setError(message);
        setLoading(false);
        displayError(message);
      }
    };

    authenticate();
  }, []);

  if (loading) {
    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center"
        style={{ minHeight: '80vh' }}
      >
        <Loader />
        <h5 className="mt-3 text-muted">Verifying your credentials...</h5>
      </div>
    );
  }

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center p-3"
      style={{ minHeight: '80vh' }}
    >
      <div
        className="card shadow-sm p-4 text-center"
        style={{ maxWidth: '480px', width: '100%', borderRadius: '8px' }}
      >
        <h4 className="text-danger mb-3 font-weight-bold">
          Authentication Failed
        </h4>
        <p className="text-secondary mb-4">{error}</p>
        <div className="d-flex justify-content-center">
          <Button
            color="primary"
            onClick={() => {
              window.location.href = getSSOLoginUrl();
            }}
          >
            Retry Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SSO;
